import "antd/dist/antd.min.css";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.js";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store, persistor } from "./redux/store/index.js";
import { PersistGate } from "redux-persist/integration/react";

// Suppress ResizeObserver loop error (harmless browser warning)
const resizeObserverErr = window.onerror;
window.onerror = (message, ...args) => {
  if (message && message.includes('ResizeObserver loop')) {
    return true;
  }
  if (resizeObserverErr) {
    return resizeObserverErr(message, ...args);
  }
};

// Send web vitals to PostHog with safety check
const sendToPostHog = (metric) => {
  try {
    if (window.posthog && !window.navigator.doNotTrack) {
      window.posthog.capture("$web_vitals", {
        $web_vital_metric: metric.name,
        $web_vital_value: metric.value,
        $web_vital_rating: metric.rating,
        $web_vital_id: metric.id,
        path: window.location.pathname,
        navigationEntry: metric.entries?.[0]?.name || null,
        deviceType: window.innerWidth < 768 ? "mobile" : "desktop",
      });
    }
  } catch (error) {
    // Silently handle PostHog errors
  }
};

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
);

reportWebVitals(sendToPostHog);
